<template>
<div class="form-group">
  <label for="provider-id">
    {{ label }}
  </label>

  <select
    :name="selectName"
    id="provider-id"
    class="form-control"
    :required="required"
  >
    <option
      value=""
      v-if="label && !providerIds"
    >
      {{ label }}
    </option>
    <option v-if="loading">
      Loading...
    </option>
    <option
      v-else
      value=""
    >
      Select {{ label }}
    </option>
    <option
      v-for="provider in providers"
      :key="provider.id"
      :value="provider.id"
      :selected="isSelected(provider)"
      v-on:click.stop="optionSelected"
    >
      {{ provider.title }}
    </option>
  </select>
</div>
</template>

<script>
import ProvidersMixin from '@/mixins/ProvidersMixin'

import ProvidersStore from '@/stores/ProvidersStore'

export default {
  data () {
    let state = ProvidersStore.state
    state.selectedId = ''

    return state
  },

  mixins: [
    ProvidersMixin
  ],

  props: {
    admin: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      default: undefined
    },

    name: {
      type: String,
      default: undefined
    },

    providerId: {
      type: [ Number, String ],
      default: ''
    },

    providerIds: {
      type: [ Array ],
      default: () => {
        return []
      }
    },

    required: {
      type: [ Boolean, String ],
      default: false
    },

    selectName: {
      type: String,
      default: 'puzzle[provider_id]'
    }
  },

  created () {
    this.loading = true

    this.providers = []
    this.getProviders().then((resp) => {
      this.providers = resp

      this.sortProviders()
      this.loading = false
    })
  },

  methods: {
    change (ev) {
      const target = ev.srcElement

      // @WIP This currently only finds the first selected item.
      const opt = target.options[target.selectedIndex]
      const selectedProvider = this.getProviderById(opt.value)

      this.$parent.$emit('providerSelected', selectedProvider)
    },

    isSelected (provider) {
      if (this.providerId) {
        return parseInt(provider.id) === parseInt(this.providerId)
      } else if (this.providerIds) {
        return this.providerIds.includes(provider.id)
      }
    },

    getProviderById (pid) {
      return this.providers.find(({ id }) => {
        return id === pid
      })
    },

    optionSelected (ev) {
      const selectedProvider = this.getProviderById(ev.target.value)
      this.$parent.$emit('providerSelected', selectedProvider)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/ProviderPicker.vue